import { createAsyncThunk } from "@reduxjs/toolkit";
import { getObjectsLocations } from "domain/objects/api/get-objects-locations";
import { ObjectsLocationsRequestDto } from "domain/objects/entities/dtos/objects-locations-request.dto";

const getObjectsLocationsAction = createAsyncThunk(
  "objects/v2/getObjectsLocation",
  async (payload: ObjectsLocationsRequestDto) => {
    return await getObjectsLocations(payload);
  }
);

export default getObjectsLocationsAction;
